// Resource definition for React Admin
export const feeSchedulesResource = {
  name: 'Fee Schedules',
  fields: {
    id: 'ID',
    name: 'Name',
    entityType: 'Entity Type',
    entityId: 'Entity',
    entity: 'Entity',
    templateId: 'Fee Template',
    template: 'Template',
    customStructure: 'Custom Structure',
    isActive: 'Active',
    active: 'Active',
    effectiveDate: 'Effective Date',
    effectiveFrom: 'Effective From',
    effectiveUntil: 'Effective Until',
    expiryDate: 'Expiry Date',
    priority: 'Priority',
    currency: 'Currency',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    site: 'Site',
    loadGroup: 'Load Group',
    charger: 'Charger',
    hierarchy: 'Hierarchy',
    selectEntity: 'Select {type}',
    allLoadGroups: 'All Load Groups',
    noTemplate: 'No Template',
    templateHelper: 'Choose a fee template or use custom structure',
    priorityHelper: 'Lower numbers have higher priority (1 = highest)',
    entityName: 'Entity Name',
    status: 'Status',
    indefinite: 'Indefinite',
    duration: 'Duration',
    effectivePeriod: 'Effective Period',
    components: 'Components',
    effectiveUntilHelper: 'Leave empty for indefinite schedule',
    createdBy: 'Created By',
    description: 'Description',
  },
};

// Custom fee schedules translations
export const feeSchedules = {
  name: 'Fee Schedules',
  fields: {
    id: 'ID',
    name: 'Name',
    entityType: 'Entity Type',
    entityId: 'Entity',
    entity: 'Entity',
    templateId: 'Fee Template',
    template: 'Template',
    customStructure: 'Custom Structure',
    isActive: 'Active',
    active: 'Active',
    effectiveDate: 'Effective Date',
    effectiveFrom: 'Effective From',
    effectiveUntil: 'Effective Until',
    expiryDate: 'Expiry Date',
    priority: 'Priority',
    currency: 'Currency',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    site: 'Site',
    loadGroup: 'Load Group',
    charger: 'Charger',
    hierarchy: 'Hierarchy',
    selectEntity: 'Select {type}',
    allLoadGroups: 'All Load Groups',
    noTemplate: 'No Template',
    templateHelper: 'Choose a fee template or use custom structure',
    priorityHelper: 'Lower numbers have higher priority (1 = highest)',
    entityName: 'Entity Name',
    status: 'Status',
    indefinite: 'Indefinite',
    duration: 'Duration',
    effectivePeriod: 'Effective Period',
    components: 'Components',
    effectiveUntilHelper: 'Leave empty for indefinite schedule',
    createdBy: 'Created By',
    description: 'Description',
  },
  entityTypes: {
    site: 'Site',
    load_group: 'Load Group',
    charger: 'Charger',
  },
  list: {
    title: 'Fee Schedules',
    filters: {
      search: 'Search by name',
      entityType: 'Entity Type',
      templateId: 'Template',
      activeOnly: 'Active Only',
      site: 'Site',
    },
  },
  create: {
    title: 'Create Fee Schedule',
    subtitle: 'Assign fee structure to an entity',
    infoMessage: 'Create a fee schedule to apply pricing to specific sites, load groups, or chargers. Schedules with higher priority (lower numbers) will override lower priority schedules.',
    basicInfo: 'Basic Information',
    entitySelection: 'Entity Selection',
    feeConfiguration: 'Fee Configuration',
    feeConfig: 'Fee Configuration',
    scheduleConfig: 'Schedule Configuration',
    schedule: 'Schedule',
    nameHelper: 'Descriptive name for this fee schedule',
    entityHelper: 'Select the entity this fee schedule applies to',
    templateHelper: 'Choose a template or create custom fee structure',
    effectiveDateHelper: 'When this fee schedule becomes active',
    expiryDateHelper: 'When this fee schedule expires (optional)',
    configurationOptions: 'Configuration Options',
    useTemplate: 'Use Fee Template',
    useCustom: 'Custom Fee Structure',
    customFees: 'Custom Fee Structure',
    templateInfo: 'Using a template will inherit all fee components and rates from the selected template.',
    customFeeWarning: 'Custom fee structures require manual configuration of all pricing components.',
    priorityInfo: 'Priority determines which schedule takes precedence when multiple schedules apply to the same entity.',
    overlapWarning: 'Ensure effective dates do not create conflicting schedules for the same entity.',
    backToList: 'Back to Fee Schedules',
  },
  edit: {
    title: 'Edit %{name}',
    subtitle: 'Modify fee schedule configuration',
    basicInfo: 'Basic Information',
    entitySelection: 'Entity Selection',
    feeConfiguration: 'Fee Configuration',
    schedule: 'Schedule',
    scheduleConfig: 'Schedule Configuration',
    feeConfig: 'Fee Configuration',
    useTemplate: 'Use Fee Template',
    customFees: 'Custom Fee Structure',
    statusInfo: 'Status Information',
    hasAdjustmentsWarning: 'This schedule has fee adjustments. Some settings cannot be modified.',
    entityChangeDisabled: 'Entity cannot be changed when adjustments exist',
    feeStructureChangeDisabled: 'Fee structure cannot be changed when adjustments exist',
    currentTemplate: 'Currently using template: {name} ({currency})',
    noTemplate: 'No template selected',
    templateCannotChange: 'Template cannot be changed after creation. To use a different template, create a new schedule.',
    templateInfo: 'Using a template will inherit all fee components and rates from the selected template.',
    customFeeWarning: 'Changes to custom fee structure will affect active schedules',
    priorityInfo: 'Lower numbers have higher priority (1 = highest)',
    overlapWarning: 'Check for overlapping schedules that might conflict',
    deleteSchedule: 'Delete Schedule',
    deleteScheduleDescription: 'Permanently delete this fee schedule',
    entityCannotChange: 'Entity cannot be changed after creation',
    backToList: 'Back to Fee Schedules',
    nameHelper: 'Descriptive name for this fee schedule',
    effectiveDateHelper: 'When this fee schedule becomes active',
    expiryDateHelper: 'When this fee schedule expires (optional)',
  },
  show: {
    title: 'Fee Schedule Details',
    subtitle: 'View schedule configuration and effective pricing',
    basicInfo: 'Basic Information',
    entityInfo: 'Entity Information',
    entityType: 'Entity Type',
    entityName: 'Entity Name',
    feeConfiguration: 'Fee Configuration',
    effectivePricing: 'Effective Pricing',
    scheduleStatus: 'Schedule Status',
    status: 'Status',
    metadata: 'Metadata',
    usingTemplate: 'Using fee template: %{name}',
    customConfiguration: 'Using custom fee configuration',
    noFeeStructure: 'No fee structure configured',
    noEnabledComponents: 'No fee components are currently enabled in this schedule.',
    enabledComponents: 'Enabled Components',
    component: 'Component',
    configuration: 'Configuration',
    specialDates: 'Special Dates',
    specialDatesCount: '{count} special dates configured',
  },
  validation: {
    nameRequired: 'Schedule name is required',
    entityRequired: 'Entity selection is required',
    templateOrCustomRequired: 'Either template or custom structure is required',
    effectiveDateRequired: 'Effective date is required',
    expiryAfterEffective: 'Expiry date must be after effective date',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    future: 'Future',
    expired: 'Expired',
  },
  notifications: {
    created: 'Fee schedule created successfully',
    updated: 'Fee schedule updated successfully',
    deleted: 'Fee schedule deleted successfully',
  },
};